import React from 'react';
import { IIconProps } from './utils';

export const Assign = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  stroke,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 24 26" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M7.39423 2.61539H5.08654C3.17478 2.61539 1.625 4.16518 1.625 6.07693V9.53847M7.39423 2.61539V1.46155M7.39423 2.61539H16.625M7.39423 2.61539V3.76924M16.625 2.61539H18.9327C20.8444 2.61539 22.3942 4.16518 22.3942 6.07693V9.53847M16.625 2.61539V1.46155M16.625 2.61539V3.76924M1.625 9.53847V21.0769C1.625 22.9887 3.17478 24.5385 5.08654 24.5385H12.5865M1.625 9.53847H22.3942M22.3942 9.53847V14.1539M18.9327 20.5V17.6154M18.9327 20.5V23.3846M18.9327 20.5H21.8173M18.9327 20.5H16.0481" stroke={stroke || fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.36538" />
  </svg>
);
